import { KatButton } from '@amzn/katal-react';
import { DeviceFamily, Placement } from '@amzn/fire-tv-campaign-automation-service';

import { LocaleSelector } from './LocaleSelector';
import { PlacementSelector } from './PlacementSelector';
import { FeatureFlag, isFeatureEnabled } from 'src/featureFlags';
import { useSelection } from 'src/contexts/SelectionContext';
import { useDevicePreviewNavigation } from '../preview/devicePreview/DevicePreviewNavigationContext';
import styles from './SelectSection.module.css';

const SelectSection = () => {
  const { openTestCampaignModal } = useDevicePreviewNavigation();
  const { deviceFamily, placement } = useSelection();

  return (
    <section className={styles.container}>
      <div className={styles.selectors}>
        <PlacementSelector />
        <LocaleSelector />
        {isFeatureEnabled(FeatureFlag.RdpIntegration) &&
          deviceFamily === DeviceFamily.FIRE_TV &&
          placement === Placement.FEATURE_ROTATOR && (
            <div className={styles.testCampaign}>
              <KatButton variant="primary" label="Test Campaign" onClick={openTestCampaignModal} />
            </div>
          )}
      </div>
    </section>
  );
};

export { SelectSection };
